import script from "./UserList.vue?vue&type=script&setup=true&lang=js"
export * from "./UserList.vue?vue&type=script&setup=true&lang=js"

import "./UserList.vue?vue&type=style&index=0&id=795df3e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-795df3e2"]])

export default __exports__